import Header from "../../Common/Header";
import Estate from "../../Components/Estate";

const EsatetPage = () => {
  return (
        <>
          <Estate />
        </>
  );
};

export default EsatetPage;
